<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <account-header settingName="Payments"></account-header>
    <div class="row justify-center">
      <div class="col-lg-2"></div>
      <div class="col-lg-8">
        <h3 class="mt-4">My Payments</h3>
        <div class="row mt-4 mb-4">
          <div class="col-md-12">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Room</th>
                  <th scope="col">Check In</th>
                  <th scope="col">Check Out /th></th>
                  <th scope="col">Amount</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in 10">
                  <th scope="row">{{i}}</th>
                  <td>Double Deluxe</td>
                  <td>12-01-2019</td>
                  <td>12-01-2019</td>
                  <td>98</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-info btn-sm"
                      data-toggle="modal"
                      data-target="#viewPaymentModal"
                    >View</button>
                    <button type="button" class="btn btn-danger btn-sm">Remove</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- login and register modal -->
    <!-- ===================================================== -->
    <div
      class="modal fade"
      id="viewPaymentModal"
      aria-labelledby="loginRegisterModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Payment Details</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-md-4">
                  <h6>Invoice #002</h6>
                  <p>14 December 2019</p>
                </div>
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <img src="/logo.png" alt>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <p>FROM:</p>
                  <span>
                    <b>Ogeyi's Place</b>
                  </span>
                  <p>
                    39 Timber Road,
                    Los Angeles, CA 97446
                    United States
                  </p>
                </div>

                <div class="offset-lg-4 col-lg-4">
                  <p>To:</p>
                  <span>
                    <b>Ogeyi's Place</b>
                  </span>
                  <p>
                    39 Timber Road,
                    Los Angeles, CA 97446
                    United States
                  </p>
                </div>
                <div class="col-lg-12">
                  <table class="table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Room</th>
                        <th scope="col">Check In</th>
                        <th scope="col">Check Out /th></th>
                        <th scope="col">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">1</th>
                        <td>Double Deluxe</td>
                        <td>12-01-2019</td>
                        <td>12-01-2019</td>
                        <td>
                          <b>185</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <span>All amounts shown on this invoice are in US dollars.</span>
                </div>

                <div class="col-lg-12">
                  <h6>Payment Details</h6>
                  <div class="row mt-4">
                    <div class="col-lg-3">
                      <h6>
                        <b>Accessibility</b>
                      </h6>
                      <ul class="list mt-2">
                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            non smoking
                          </label>
                        </li>
                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            smoking
                          </label>
                        </li>
                      </ul>
                    </div>

                    <div class="col-lg-3">
                      <h6>
                        <b>Location</b>
                      </h6>
                      <ul class="list mt-2">
                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            high floor
                          </label>
                        </li>
                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            low floor
                          </label>
                        </li>

                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            near elevator
                          </label>
                        </li>
                      </ul>
                    </div>

                    <div class="col-lg-3">
                      <h6>
                        <b>Room Features</b>
                      </h6>
                      <ul class="list mt-2">
                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            crib or pack and play
                            <span>request only</span>
                          </label>
                        </li>
                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            Rollaway bed
                          </label>
                        </li>

                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            Extra feather pillows
                          </label>
                        </li>

                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            Extra foam pillows
                          </label>
                        </li>

                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            foam pillows
                          </label>
                        </li>

                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            feather free room
                          </label>
                        </li>
                      </ul>
                    </div>

                    <div class="col-lg-3">
                      <h6>
                        <b>Room Features</b>
                      </h6>
                      <ul class="list mt-2">
                        <li class="list__item">
                          <label class="label--checkbox">
                            <input disabled checked type="checkbox" name="smoking" class="checkbox">
                            Extra towels
                            <span>request only</span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-download btn-sm">Email</button>
            <button type="button" class="btn btn-download btn-sm">Print</button>
            <button type="button" class="btn btn-info btn-sm">Download PDF</button>

            <button
              type="button"
              class="btn btn-info btn-sm"
              data-toggle="modal"
              data-target="#viewPaymentModal"
            >Print</button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accountHeader from "@/components/accountHeader.vue";
export default {
  name: "reservations",
  components: { "account-header": accountHeader }

  // components: {
  //   headerNav
  // }
};
</script>
